import { ExternalLink } from 'lucide-react';

/**
 * A dashboard → report drill-down link.
 *
 * Opens in a NEW TAB by design: the point of the link is to VERIFY a dashboard
 * number against its source, so the dashboard (its month, filters and scroll
 * position) must survive the trip. `rel="noopener noreferrer"` because
 * target="_blank" otherwise hands the opened page a window.opener handle.
 *
 * Renders as an inline element so it can sit inside a table cell next to the
 * value it explains, without disturbing the row's layout.
 */
export function DrillLink({
  href,
  children,
  title,
  className = '',
  showIcon = true,
}: {
  href: string;
  children: React.ReactNode;
  /** Tooltip — say WHERE it goes and WITH WHAT filters, e.g. "Open Daily Attendance for this employee, 12 Jul – 5 Aug". */
  title?: string;
  className?: string;
  showIcon?: boolean;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      // stopPropagation: several of these tables have row-level click handlers
      // (drill-down modals). Without it, clicking the link would ALSO trigger
      // the row action behind it.
      onClick={(e) => e.stopPropagation()}
      className={`group inline-flex items-center gap-1 rounded text-primary-600 underline-offset-2 hover:text-primary-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 ${className}`}
    >
      {children}
      {showIcon && (
        <ExternalLink className="h-3 w-3 flex-shrink-0 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100" />
      )}
    </a>
  );
}

export default DrillLink;
